import React from 'react';
import { useSelector } from 'react-redux';

import { buyerAlertUrl } from '../../../../../utils/buyerAlertUrl';

const BuyerAlertLink = () => {
  const { display: displayMap } = useSelector((state) => state.mapSettings);
  const { selectedTab, baseCollection: filters, filtersChanged } = useSelector((state) => state.filters);
  const { desktopDevice } = useSelector((state) => state.viewportSlice);

  if (displayMap || desktopDevice || selectedTab === 'mobileFilters') return null;

  return (
    <div className='fixed-cta-alert vesta-w-full'>
      <a href={buyerAlertUrl(filters)} target='_blank' rel='noreferrer nofollow' className='vesta-button--primary vesta-button--small'>
        <i className='fa fa-bell vesta-button--icon-left'></i>
        <span className='typo-h4'>{filtersChanged ? 'Enregistrer ma recherche' : 'Recevoir des biens en exclusivité'}</span>
      </a>
    </div>
  )
};

export default BuyerAlertLink;
